import { render, staticRenderFns } from "./abouts.vue?vue&type=template&id=17a3a73c&scoped=true"
import script from "./abouts.vue?vue&type=script&lang=js"
export * from "./abouts.vue?vue&type=script&lang=js"
import style0 from "./abouts.vue?vue&type=style&index=0&id=17a3a73c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a3a73c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17a3a73c')) {
      api.createRecord('17a3a73c', component.options)
    } else {
      api.reload('17a3a73c', component.options)
    }
    module.hot.accept("./abouts.vue?vue&type=template&id=17a3a73c&scoped=true", function () {
      api.rerender('17a3a73c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/about/abouts.vue"
export default component.exports